import { render, staticRenderFns } from "./TopBannerTheme2.vue?vue&type=template&id=1940d89e&scoped=true"
import script from "./TopBannerTheme2.vue?vue&type=script&lang=js"
export * from "./TopBannerTheme2.vue?vue&type=script&lang=js"
import style0 from "./TopBannerTheme2.vue?vue&type=style&index=0&id=1940d89e&prod&lang=css"
import style1 from "./TopBannerTheme2.vue?vue&type=style&index=1&id=1940d89e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1940d89e",
  null
  
)

export default component.exports